// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.globalHomeContentDiv h4 {
    text-align: center;
}

.userBannerHome {
    display: block;
    margin-left: auto;
    margin-right: auto;
    animation: colorBanner 20s infinite;
    transition: background-color 5s ease;
    background-color: #66ffff;
    min-height: 100px;
    max-width: 80%;
    border-radius: 8px;
    text-align: center;
    line-height: 90px;
}

.userBannerText {
    font-size: 1.8em;
    text-align: center;
}

@keyframes colorBanner {
    0% {
        background-color: #04ffec;
    }

    50% {
        background-color: #04ff67;
    }

    100% {
        background-color: #04ffec;
    }
}

@media only screen and (max-width: 768px) {
    .userBannerText {
        font-size: 1.1rem;
    }
}
`, "",{"version":3,"sources":["webpack://./src/components/Dashboard/Home/HomeContent/HomeContent.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;AACtB;;AAEA;IACI,cAAc;IACd,iBAAiB;IACjB,kBAAkB;IAClB,mCAAmC;IACnC,oCAAoC;IACpC,yBAAyB;IACzB,iBAAiB;IACjB,cAAc;IACd,kBAAkB;IAClB,kBAAkB;IAClB,iBAAiB;AACrB;;AAEA;IACI,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI;QACI,yBAAyB;IAC7B;;IAEA;QACI,yBAAyB;IAC7B;;IAEA;QACI,yBAAyB;IAC7B;AACJ;;AAEA;IACI;QACI,iBAAiB;IACrB;AACJ","sourcesContent":[".globalHomeContentDiv h4 {\n    text-align: center;\n}\n\n.userBannerHome {\n    display: block;\n    margin-left: auto;\n    margin-right: auto;\n    animation: colorBanner 20s infinite;\n    transition: background-color 5s ease;\n    background-color: #66ffff;\n    min-height: 100px;\n    max-width: 80%;\n    border-radius: 8px;\n    text-align: center;\n    line-height: 90px;\n}\n\n.userBannerText {\n    font-size: 1.8em;\n    text-align: center;\n}\n\n@keyframes colorBanner {\n    0% {\n        background-color: #04ffec;\n    }\n\n    50% {\n        background-color: #04ff67;\n    }\n\n    100% {\n        background-color: #04ffec;\n    }\n}\n\n@media only screen and (max-width: 768px) {\n    .userBannerText {\n        font-size: 1.1rem;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
